

export class UbigeoBean{
  public id:number;
  public codigoDepartamento:string;
  public codigoProvincia:string;
  public codigoDistrito:string;
  public nombreUbigeo:string;
}
